import React, { ReactElement, ReactNode } from 'react';
import { cn } from 'utils';

export type JobsiteInfoBaseCardField = {
  label: string;
  value: ReactNode;
};

export type JobsiteInfoBaseCardProps = {
  label: string;
  title: ReactNode;
  subtitle?: ReactNode;
  headerActions?: ReactNode;
  fields: JobsiteInfoBaseCardField[];
  footer?: ReactNode;
};

export function JobsiteInfoBaseCard(
  props: JobsiteInfoBaseCardProps,
): ReactElement {
  const { label, title, subtitle, headerActions, fields, footer } = props;

  return (
    <div
      className={cn(
        'odin-flex odin-flex-col odin-gap-5',
        'odin-rounded-2xl odin-border odin-border-odin-medium-gray',
        'odin-bg-odin-white odin-p-6',
      )}
    >
      <div className="odin-flex odin-items-start odin-justify-between odin-gap-3">
        <div className="odin-flex odin-flex-col odin-gap-2 odin-min-w-0">
          <span className="odin-text-sm odin-text-odin-navy odin-mb-3">
            {label}
          </span>
          <div className="odin-flex odin-flex-col odin-gap-0.5">
            <span className="odin-text-lg odin-font-semibold odin-text-odin-navy odin-leading-tight">
              {title}
            </span>
            {subtitle && (
              <span className="odin-text-sm odin-text-odin-navy">
                {subtitle}
              </span>
            )}
          </div>
        </div>
        {headerActions && (
          <div className="odin-flex odin-items-center odin-gap-3 odin-shrink-0">
            {headerActions}
          </div>
        )}
      </div>
      <div className="odin-grid odin-grid-cols-1 sm:odin-grid-cols-2 odin-gap-4">
        {fields.map(({ label: fieldLabel, value }) => (
          <div key={fieldLabel} className="odin-flex odin-flex-col odin-gap-1">
            <span className="odin-text-sm odin-text-odin-navy">
              {fieldLabel}
            </span>
            <span className="odin-text-sm odin-font-semibold odin-text-odin-navy">
              {value}
            </span>
          </div>
        ))}
      </div>
      {footer && <div className="odin-mt-auto">{footer}</div>}
    </div>
  );
}
